import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const { data } = await api.get('/auth/me');
    setUser(data.user);
    setCompany(data.company);
    return data;
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      refreshMe()
        .catch(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [refreshMe]);

  // Enregistre une session complète (après login direct, vérification MFA
  // ou enrôlement MFA forcé).
  const completeLogin = useCallback((data) => {
    localStorage.setItem('token', data.token);
    if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
    setUser(data.user);
    refreshMe().catch(() => {});
  }, [refreshMe]);

  // Renvoie la réponse brute : le composant Login gère les étapes MFA
  // ({ mfaRequired } / { mfaSetupRequired }).
  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data.token) completeLogin(data);
    return data;
  };

  const logout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      try { await api.post('/auth/logout', { refreshToken }); } catch { /* best effort */ }
    }
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    setUser(null);
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ user, company, loading, login, completeLogin, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
